import styles from './CustomerCluster.module.css'
import { HospitalPicker } from './HospitalPicker'
import { UserMenu } from './UserMenu'

/**
 * The header's top-right identity area.
 */
export const CustomerCluster = () => {
  return (
    <div className={styles.cluster}>
      <HospitalPicker />
      <UserMenu />
    </div>
  )
}
